<button (click)="toggle()" class="button-ghost-gray h-34px !text-large-regular">
    <span class="text-primary-text-color" i18n=":@@price-in">Price in:</span>
    <span class="text-dark">{{ title() }}</span>
    <companyid-chevron color="black" position="bottom" smallSize />
</button>
@if (isShown()) {
    <ul
        companyidClickOutside
        (onClickOutside)="toggle()"
        class="z-50 absolute text-medium-regular text-primary-text-color rounded-6px box-shadow-2 p-5px bg-white w-[220px] mt-2"
    >
        @for (item of currencyItems; track item) {
            <li
                aria-hidden="true"
                class="hover:bg-dark-4 hover:text-white w-full px-15px py-2 cursor-pointer h-[40px] rounded-6px"
                (click)="changeCurrency(item)"
            >
                {{ item }}
            </li>
        }
    </ul>
}
